import { FormattedMessage } from 'react-intl';

import { iconCreditCard } from '#src/atoms/icons/system/iconCreditCard.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { PaymentMethodIcon } from '#src/components/paymentMethods/Icon/index.tsx';

export const NewCreditCard = () => {
  return (
    <Horizontal gap={1}>
      <PaymentMethodIcon icon={iconCreditCard} />
      <BodyM color="var(--c-white)">
        <FormattedMessage defaultMessage="New credit card" />
      </BodyM>
    </Horizontal>
  );
};
